import React, { useState } from 'react'
import { Col, Modal, Row, Form } from 'react-bootstrap';
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from '../../API/axios';


const AddExperienceRole = ({ getUserCv, userDataId, handleCloseExperienceRole, showExperienceRole, experienceData }) => {
    // console.log('experienceData', experienceData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    const [role, setRole] = useState('');
    const [display, setDisplay] = useState(false);

    const [formChanged, setFormChanged] = useState(false); // Track if form is modified
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Handle changes and mark form as modified
    const handleFieldChange = (setter, value) => {
        setter(value);
        // setFormChanged(true); // Enable Submit button
        setFormChanged(value.trim() !== ""); // Enable button only if input has value
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        setIsSubmitting(true); 
        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
            expId: experienceData.usrDataExpId,
            role: role
        };
        console.log("body", body);
        if (role === '') {
            toast.error('Please fill all the required fields');
            setIsSubmitting(false); // Re-enable the button if validation fails
        } else {
            try {
                const res = await axios.post("/Resume/AddExperienceRole", body);
                toast.success(res.data.message);
                resetForm();
                setFormChanged(false); // Reset formChanged to allow future edits
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response?.data?.message || "An error occurred");
                }
            } finally {
                setIsSubmitting(false); // Re-enable the button after submission
            }

        }
    };

    const resetForm = () => {
        handleCloseExperienceRole();
        getUserCv();
        setRole('')
        setDisplay(false)
        setFormChanged(false); // Disable the button after update
    }
    const handleCloseExperienceRoleFn = () => {
        resetForm(); // Call resetForm when closing the modal
        handleCloseExperienceRole();
    };

    return (
        <Modal show={showExperienceRole} onHide={handleCloseExperienceRoleFn} centered size="lg">
            <Modal.Header>
                <Modal.Title>Add experience role</Modal.Title>
                <CloseSharpIcon className="pointer" onClick={handleCloseExperienceRoleFn} />
            </Modal.Header>
            <Modal.Body className="settings">
                <Row>
                    <Col md={12}>
                        <Form.Group controlId="grade">
                            <Form.Label className="class-type">Role <span style={{ color: "red" }}> *</span></Form.Label>
                            <Form.Control
                                type="text"
                                className=' Dark-Input-from-group'
                                value={role}
                                // onChange={(e) => setRole(e.target.value)}
                                onChange={(e) => handleFieldChange(setRole, e.target.value)} // Track changes
                                placeholder="Enter role"
                            />
                            {display && !role ? (
                                <span className="error_msg_lbl">Add role </span>
                            ) : null}
                        </Form.Group>
                    </Col>

                </Row>

                <div className="d-flex justify-content-end mt-4">
                    <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                        <div className="khojPrimaryBtn ms-3"
                         onClick={handleSubmit}
                         style={{cursor: formChanged ? "pointer" : "default"}}
                        >
                            <a href="#/"
                                // onClick={handleSubmit}
                                className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
                            >
                                Submit
                            </a>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddExperienceRole